import { TOKEN_GROUP_LABELS, type TokenGroup } from "@gatiq/shared";

/**
 * The branding field groups, in the order they appear as tabs, each with the
 * URL segment that selects it.
 *
 * The segments are deliberately not the raw token-group keys: `semantic` is a
 * word from the token registry, not something a person would recognise in an
 * address bar, and the tab is labelled "Status colors". URLs are read by
 * people, so they get the label's wording.
 */
export const BRANDING_GROUPS: ReadonlyArray<{ group: TokenGroup; slug: string; label: string }> = (
  [
    ["identity", "identity"],
    ["brand", "brand-colors"],
    ["semantic", "status-colors"],
    ["typography", "typography"],
    ["shape", "shape"],
    ["layout", "layout"],
    ["contact", "contact"],
  ] as const
).map(([group, slug]) => ({ group, slug, label: TOKEN_GROUP_LABELS[group] }));

export const DEFAULT_BRANDING_GROUP = BRANDING_GROUPS[0]!;

/** `undefined` for anything that is not a branding group — the caller 404s or redirects. */
export function groupForSlug(slug: string | undefined): TokenGroup | undefined {
  return BRANDING_GROUPS.find((g) => g.slug === slug)?.group;
}
